import { FILE_EXTENSION, FILE_MIME, SOFTWARE_NAME } from '../config.ts';

export function triggerBlobDownload(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.rel = 'noopener';
  a.click();
  URL.revokeObjectURL(url);
}

export function defaultEncryptedFilename(originalName?: string): string {
  if (!originalName) return `encrypted${FILE_EXTENSION}`;
  const base = originalName.replace(/\.[^/.]+$/, '') || 'file';
  return `${base}${FILE_EXTENSION}`;
}

export function defaultDecryptedFilename(metaName?: string): string {
  return metaName && metaName.trim() ? metaName : `decrypted-by-${SOFTWARE_NAME}.bin`;
}

export function zerocryptBlob(bytes: Uint8Array): Blob {
  // Copy to a standalone ArrayBuffer (not SharedArrayBuffer) for BlobPart typing.
  const copy = new Uint8Array(bytes.byteLength);
  copy.set(bytes);
  return new Blob([copy], { type: FILE_MIME });
}
